<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-width="1rem">
          <el-form-item label="所属部门" prop="deptIds">
            <el-cascader
              key="el1"
              ref="cascaderDet"
              style="width: 100%"
              v-model="form.deptIds"
              :options="deptList"
              :props="{
                checkStrictly: true,
                value: 'deptId',
                label: 'deptName',
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="所属角色" prop="roleId">
            <el-select
              style="width: 100%"
              v-model="form.roleId"
              filterable
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登录账号" prop="account">
            <el-input
              v-model="form.account"
              clearable
              autocomplete="off"
              maxlength="30"
              placeholder="请输入登录账号"
            />
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model="form.phone"
              clearable
              :disabled="!!form.userId"
              :readonly="!!form.userId"
              autocomplete="off"
              maxlength="11"
              placeholder="请输入手机号码"
            />
          </el-form-item>
          <el-form-item label="密码" :prop="form.userId ? '' : 'password'">
            <el-input
              v-model.trim="form.password"
              clearable
              autocomplete="off"
              type="password"
              show-password
              maxlength="20"
              placeholder="请输入6-20位登录密码"
            />
          </el-form-item>
          <el-form-item label="姓名" prop="username">
            <el-input
              v-model.trim="form.username"
              clearable
              :disabled="!!form.userId"
              :readonly="!!form.userId"
              autocomplete="off"
              placeholder="请输入姓名"
            />
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="form.status"
              :inactive-value="0"
              :active-value="1"
              size="medium"
              active-color="#526BEC"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, detailInfo, editInfo } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
import { getAllTree } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加/编辑账号",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        account: "",
        deptIds: [],
        deptId: "",
        password: "",
        phone: "",
        roleId: "",
        status: 0,
        terminalType: "",
        username: "",
      },
      rules: {
        account: [{ required: true, message: "登录账号不能为空" }],
        deptIds: [{ required: true, message: "部门不能为空", trigger: "blur" }],
        password: [{ required: true, message: "登录密码不能为空" }],
        terminalType: [{ required: true, message: "来源不能为空" }],
        username: [{ required: true, message: "姓名不能为空" }],
        phone: [
          { required: true, message: "手机号不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        roleId: [{ required: true, message: "所属角色不能为空" }],
      },
      roleList: [],
      deptList: [],
      loading: false, // 角色loading
    };
  },
  // watch: {
  //   "form.terminalType": {
  //     handler(val) {
  //       this.form.roleId = null;
  //       this.getRoleData(val);
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  mounted() {},
  methods: {
    getTree() {
      getAllTree().then((res) => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },
    getRoleData(terminalType) {
      getRoleSelect(terminalType).then((res) => {
        if (res.code === 200) {
          this.roleList = res.data;
        }
      });
    },
    getDetail(userId) {
      detailInfo(userId).then((res) => {
        if (res.code === 200) {
          let arr = res.data.deptFullPath.split(",");

          this.form.deptIds = [...arr];
          this.form.account = res.data.account;
          this.form.deptId = res.data.deptId;
          this.form.password = res.data.password ? res.data.password : "";
          this.form.phone = res.data.phone;
          this.form.roleId = res.data.roleId;
          this.form.userId = res.data.userId;
          this.form.status = res.data.status;
          this.form.terminalType = res.data.terminalType;
          this.form.username = res.data.username;
        }
      });
    },
    init(terminalType, row) {
      this.form.terminalType = terminalType;

      setTimeout(() => {
        this.getRoleData(terminalType);
        this.getTree();
      }, 100);

      if (!!row) {
        this.getDetail(row.userId);
        this.dialogObj.title = "编辑账号";
      } else {
        this.dialogObj.title = "添加账号";
        this.rules.password.push({
          required: true,
          message: "登录密码不能为空",
        });
      }

      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.userId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            account: this.form.account,
            deptId: this.form.deptIds[this.form.deptIds.length - 1],
            password: this.form.password,
            phone: this.form.phone,
            roleId: this.form.roleId,
            userId: this.form.userId,
            status: this.form.status,
            terminalType: this.form.terminalType,
            username: this.form.username,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.userId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.userId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
